import "core-js/modules/es.array.concat";
import layoutHeaderAside from '@/layout/header-aside';
import store from '@/store/index'; // 由于懒加载页面太多的话会造成webpack热更新太慢，所以开发环境不使用懒加载，只有生产环境使用懒加载

var _import = require('@/libs/util.import.' + process.env.NODE_ENV); // 获取侧边栏菜单中第一个可用页面的路径


export function firstMenuPath(menus) {
  for (var i in menus) {
    if (menus[i].children && menus[i].children.length) {
      var p = firstMenuPath(menus[i].children);
      if (p) return p;
    } else if (menus[i].path) {
      return menus[i].path;
    }
  }

  return null;
}
/**
 * 在主框架内显示
 */

var frameIn = [{
  path: '/',
  redirect: function redirect() {
    return firstMenuPath(store.state.d2admin.menu.aside) || '/login';
  },
  component: layoutHeaderAside,
  children: [// { path: 'setting/accountManager', name: '/setting/accountManager', meta: {title: '账户管理', auth: true }, component: _import('pages/setting/accountManager') },
  // { path: 'setting/menuManager', name: '/setting/menuManager', meta: {title: '菜单管理', auth: true }, component: _import('pages/setting/menuManager') },
  // { path: 'setting/roleManager', name: '/setting/roleManager', meta: {title: '角色管理', auth: true }, component: _import('pages/setting/roleManager') },
  {
    path: 'log',
    name: 'log',
    meta: {
      title: '前端日志',
      auth: true
    },
    component: _import('system/log')
  }, // 系统 前端日志
  {
    path: 'refresh',
    name: 'refresh',
    hidden: true,
    component: _import('system/function/refresh')
  }, // 刷新页面 必须保留
  {
    path: 'redirect/:route*',
    name: 'redirect',
    hidden: true,
    component: _import('system/function/redirect')
  } // 页面重定向 必须保留
  ]
}];
/**
 * 在主框架之外显示
 */

var frameOut = [// 登录
{
  path: '/login',
  name: 'login',
  component: _import('system/login')
}];
/**
 * 错误页面
 */

var errorPage = [{
  path: '*',
  name: '404',
  component: _import('system/error/404')
}]; // 导出需要显示菜单的

export var frameInRoutes = frameIn; // 重新组织后导出

export default [].concat(frameOut, errorPage);